import { render, staticRenderFns } from "./TabPublished.vue?vue&type=template&id=4096c14a"
import script from "./TabPublished.vue?vue&type=script&lang=js"
export * from "./TabPublished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports